// React imports
import React from 'react';

// MUI Components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// Generic imports
import queryString from 'query-string';

// SVG Icon
import { ReactComponent as ShipIcon } from '../Error.svg';

const ErrorPage = () => {
    // Extract the organization from the query string
    const { org, reason, stack } = queryString.parse(window.location.search);

    console.error('Error:', reason, stack);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                bgcolor: '#f9f9f9',
            }}
        >
            <Box component='div' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: { xs: '80%', md: '50%' }, marginBottom: { xs: 3, md: 0 } }} >
                <ShipIcon style={{ width: '100%', height: 'auto' }} />
            </Box>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' }, width: { xs: '100%', md: '50%' } }} >
                <Typography variant='h3' gutterBottom>
                    Oops! This link has expired.
                </Typography>
                <Typography variant='body1' paragraph>
                    The link to the offer you are trying to access has expired. Please ask the sender to send you a new link to the offer.
                </Typography>
            </Box>
        </Box>
    );
};

export default ErrorPage;
